import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Popover, Box } from '@mui/material'
import '../../../../../style/filters.css'

const TestingStatusFilter = ({ filterList, onChange, index, column, filterOptions }) => {
  const [tempFilters, setTempFilters] = useState(filterList || [])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = (event) => {
    const { value, checked } = event.target
    setTempFilters((prev) => (checked ? [...prev, value] : prev.filter((item) => item !== value)))
  }

  const handleApply = () => {
    const cleaned = tempFilters.filter(Boolean) // removes "", null, undefined
    // console.log('Applying filters:', cleaned) // Update state with cleaned filters
    onChange(cleaned, index, column)
    handleClose()
  }

  const handleReset = () => {
    setTempFilters([])
    onChange([], index, column)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'testing-status-filter-popover' : undefined

  useEffect(() => {
    if (open) {
      setTempFilters(filterList || [])
    }
  }, [open, filterList])

  return (
    <div>
      <Button
        aria-describedby={id}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={{
          marginLeft: 8,
          borderColor: filterList?.length > 0 ? '#1976d2' : '',
          backgroundColor: filterList?.length > 0 ? 'rgba(25, 118, 210, 0.08)' : '',
        }}
      >
        Testing Status Filter
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: '#424242',
            color: '#ffffff',
            padding: '16px',
            width: '300px',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <div className="filter-title">Testing Status Filters</div>
          <div style={{ maxHeight: '300px', overflow: 'auto', marginBottom: '16px' }}>
            {filterOptions.testingStatuses?.map((status, i) => {
              const backgroundColor = (() => {
                switch (status?.toUpperCase()) {
                  case 'YET TO START':
                    return '#f1c40f'
                  case 'IN PROGRESS':
                    return '#3498db'
                  case 'COMPLETED':
                    return '#2ecc71'
                  case 'UNDER REVIEW':
                    return '#e67e22'
                  default:
                    return '#95a5a6'
                }
              })()
              const textColor = status?.toUpperCase() === 'YET TO START' ? '#000000' : '#ffffff'

              return (
                <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    checked={tempFilters.includes(status)}
                    onChange={handleChange}
                    value={status}
                    size="small"
                    style={{ color: '#ffffff' }}
                  />
                  <span
                    style={{
                      fontSize: '10px',
                      fontWeight: 'normal',
                      padding: '6px 12px',
                      borderRadius: '16px',
                      display: 'inline-block',
                      textTransform: 'uppercase',
                      textAlign: 'center',
                      backgroundColor,
                      color: textColor,
                      marginLeft: '8px',
                    }}
                  >
                    {status}
                  </span>
                </div>
              )
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={handleReset} className="reset-button-filter">
              Reset
            </button>
            <button onClick={handleApply} className="apply-button-filter">
              Apply
            </button>
          </div>
        </Box>
      </Popover>
    </div>
  )
}

export default TestingStatusFilter
